import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '@/components/ui/Card.jsx';
import { Button } from '@/components/ui/Button.jsx';
import { Input, FormField } from '@/components/ui/Input.jsx';
import { useAuthStore } from '@/stores/auth.js';
import { api } from '@/lib/api.js';
import { useToast } from '@/components/ui/Toast.jsx';
import { Building2 } from 'lucide-react';

export default function LoginPage() {
  const navigate = useNavigate();
  const setSession = useAuthStore((s) => s.setSession);
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: { email: 'admin@payroll.local', password: 'admin123' },
  });

   const onSubmit = async (values) => {
     setLoading(true);
     try {
       const res = await api.post('/auth/login', values);
       const { token, user } = res;
       setSession(token, user, user.permissions || []);
       navigate('/dashboard');
     } catch (e) {
       toast({ title: 'Login failed', description: e.message, variant: 'error' });
     } finally {
       setLoading(false);
     }
   };

  return (
    <div className="min-h-full grid place-items-center p-6 bg-gradient-to-br from-slate-50 via-brand-50 to-slate-100 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950">
      <Card className="w-full max-w-md">
        <CardHeader>
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-lg bg-brand-600 grid place-items-center text-white">
              <Building2 className="h-5 w-5" />
            </div>
            <div>
              <CardTitle>Payroll & HR</CardTitle>
              <CardDescription>Sign in to your account</CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent>
          <form className="space-y-4" onSubmit={handleSubmit(onSubmit)}>
            <FormField label="Email" htmlFor="email" required error={errors.email?.message}>
              <Input id="email" type="email" autoComplete="username" {...register('email', { required: 'Email is required' })} />
            </FormField>
            <FormField label="Password" htmlFor="password" required error={errors.password?.message}>
              <Input id="password" type="password" autoComplete="current-password" {...register('password', { required: 'Password is required' })} />
            </FormField>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign in'}
            </Button>
            <p className="text-xs text-slate-500 text-center">
              Default seeded admin: <code>admin@payroll.local</code> / <code>admin123</code>
            </p>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
